import { useNavigate } from 'react-router-dom';
import { useT, type Locale } from '../i18n';
import { Banner } from '../components/Banner';
import './Settings.css';

export function Settings() {
  const { t, locale, setLocale } = useT();
  const navigate = useNavigate();

  return (
    <>
      <Banner />
      <main className="settings">
        <button className="settings__back" onClick={() => navigate(-1)}>
          ← {t('settings.back')}
        </button>
        <h1 className="settings__title">{t('settings.title')}</h1>

        <section className="settings__section">
          <h2 className="settings__section-title">{t('settings.language')}</h2>
          <div className="settings__lang-row" role="radiogroup" aria-label={t('settings.language')}>
            {(['en', 'sv'] as Locale[]).map((l) => (
              <button
                key={l}
                role="radio"
                aria-checked={locale === l}
                className={`settings__lang-chip ${locale === l ? 'is-active' : ''}`}
                onClick={() => setLocale(l)}
              >
                {l === 'en' ? 'English' : 'Svenska'}
              </button>
            ))}
          </div>
        </section>

        <section className="settings__section">
          <h2 className="settings__section-title">{t('settings.about')}</h2>
          <p className="settings__about">
            singlings — v0.1 PoC. Point your phone at sheet music, four singers find the
            pitch. Open source soon.
          </p>
        </section>
      </main>
    </>
  );
}
